import HipposDashboard from "./views/HipposDashboard.js";
import LoginPage from "./views/Pages/LoginPage";
import UserListPage from "./views/Pages/hippos/UserListPage";
import LicenseListPage from "./views/Pages/hippos/LicenseListPage";
import StoreListPage from "./views/Pages/hippos/StoreListPage";
import OrderStatsPage from "views/Pages/hippos/OrderStatsPage.js";
import UserPage from "./views/Pages/hippos/UserPage";
import StorePage from "./views/Pages/hippos/StorePage";
import LicensePage from "./views/Pages/hippos/LicensePage";
import AttributeListPage from "./views/Pages/hippos/AttributeListPage";
import AttributePage from "./views/Pages/hippos/AttributePage";
import PricelistListPage from "./views/Pages/hippos/PricelistListPage.js";
import PricelistPage from "./views/Pages/hippos/PricelistPage.js";
import CategoryListPage from "views/Pages/hippos/CategoryListPage.js";
import CategoryPage from "views/Pages/hippos/CategoryPage.js";
import ProductListPage from "views/Pages/hippos/ProductListPage.js";
import ProductPage from "views/Pages/hippos/ProductPage.js";
import { Redirect } from "react-router-dom";
import TablePage from "views/Pages/hippos/TablePage.js";
import TableListPage from "views/Pages/hippos/TableListPage.js";
import TableRegionPage from "views/Pages/hippos/TableRegionPage.js";
import ProductStatsPage from "views/Pages/hippos/ProductStatsPage.js";
import PlatformSalesPage from "views/Pages/hippos/PlatformSalesPage.js";
import PaymentMethodPage from "views/Pages/hippos/PaymentMethodPage.js";
import StoreUserPage from "views/Pages/hippos/StoreUserPage.js";
import CategoryExtraListPage from "views/Pages/hippos/CategoryExtraListPage.js";
import CategoryExtraPage from "views/Pages/hippos/CategoryExtraPage.js";
import ExtraListPage from "views/Pages/hippos/ExtraListPage.js";
import ExtraPage from "views/Pages/hippos/ExtraPage.js";
import DocumentStatsPage from "views/Pages/hippos/DocumentStatsPage.js";
import SalesStatsPage from "views/Pages/hippos/SalesStatsPage.js";
import RestaurantPlanPage from "views/Pages/hippos/RestaurantPlanPage.js";
import ProductsIntegrationPage from "views/Pages/hippos/ProductsIntegrationPage.js";
import CancelledAndDestroyedPage from "views/Pages/hippos/CancelledAndDestroyedPage.js";
import UserStatsPage from "views/Pages/hippos/UserStatsPage.js";
import PaymentMethodStatsPage from "views/Pages/hippos/PaymentMethodStatsPage.js";
import HoursStatsPage from "views/Pages/hippos/HoursStatsPage.js";
import UserProductStatsPage from "views/Pages/hippos/UserProductStatsPage.js";
import TablesHistoryPage from "views/Pages/hippos/TablesHistoryPage.js";
import TablesStatsPage from "views/Pages/hippos/TablesStatsPage.js";
import DeliveryGuysSalesPage from "views/Pages/hippos/DeliveryGuysSalesPage.js";

var hipposRoutes = [
  {
    path: "/dashboard",
    layout: "/admin",
    name: "Αρχικη",
    translationKey: "navigation.home",
    icon: "nc-icon nc-chart-pie-35",
    accessLevel: 100,
    component: HipposDashboard,
  },
  {
    collapse: true,
    path: "/statistics",
    name: "ΣΤΑΤΙΣΤΙΚΑ",
    translationKey: "navigation.statistics",
    icon: "nc-icon nc-chart-bar-32",
    accessLevel: 100,
    state: "openStatisticss",
    views: [
      {
        path: "/statistics-products",
        layout: "/admin",
        name: "ΠΩΛΗΣΕΙΣ ΕΙΔΩΝ",
        translationKey: "navigation.productSales",
        accessLevel: 100,
        mini: "ΠΕ",
        component: ProductStatsPage,
      },
      {
        path: "/statistics-users",
        layout: "/admin",
        name: "ΠΩΛΗΣΕΙΣ ΧΡΗΣΤΩΝ",
        translationKey: "navigation.userSales",
        accessLevel: 100,
        mini: "ΠΧ",
        component: UserStatsPage,
      },
      {
        path: "/products-user-sales",
        layout: "/admin",
        name: "ΕΙΔΗ ΑΝΑ ΧΡΗΣΤΗ",
        translationKey: "navigation.productsByUser",
        accessLevel: 100,
        mini: "ΕΧ",
        component: UserProductStatsPage,
      },
      {
        path: "/statistics-hours",
        layout: "/admin",
        name: "ΩΡΙΑΙΕΣ ΠΩΛΗΣΕΙΣ",
        translationKey: "navigation.hourlySales",
        accessLevel: 100,
        mini: "ΩΠ",
        component: HoursStatsPage,
      },
      {
        path: "/statistics-payment-methods",
        layout: "/admin",
        name: "ΤΡ. ΠΛΗΡΩΜΗΣ",
        translationKey: "navigation.paymentMethods",
        accessLevel: 100,
        mini: "ΤΠ",
        component: PaymentMethodStatsPage,
      },
      {
        path: "/statistics-orders",
        layout: "/admin",
        name: "ΠΑΡΑΓΓΕΛΙΕΣ",
        translationKey: "navigation.orders",
        accessLevel: 100,
        mini: "ΠΑ",
        component: OrderStatsPage,
      },
      {
        path: "/statistics-sales",
        layout: "/admin",
        name: "ΚΛΕΙΣΙΜΑΤΑ",
        translationKey: "navigation.closures",
        accessLevel: 100,
        mini: "ΚΛ",
        component: SalesStatsPage,
      },
      {
        path: "/cancelled-destroyed",
        layout: "/admin",
        name: "ΑΚΥΡΩΣΕΙΣ",
        translationKey: "navigation.cancellations",
        accessLevel: 100,
        mini: "Α",
        component: CancelledAndDestroyedPage,
      },
      {
        path: "/documents",
        layout: "/admin",
        name: "ΠΑΡΑΣΤΑΤΙΚΑ",
        translationKey: "navigation.documents",
        accessLevel: 100,
        mini: "Π",
        component: DocumentStatsPage,
      },
    ],
  },
  {
    collapse: true,
    name: "ΕΣΤΙΑΤΟΡΙΟ",
    translationKey: "navigation.restaurant",
    icon: "nc-icon nc-grid-45",
    path: "/restaurant",
    accessLevel: 100,
    state: "openLive",
    views: [
      {
        path: "/live",
        layout: "/admin",
        name: "LIVE",
        translationKey: "navigation.live",
        accessLevel: 100,
        mini: "L",
        component: RestaurantPlanPage,
      },
      {
        path: "/tables-history",
        layout: "/admin",
        name: "ΙΣΤΟΡΙΚΟ",
        translationKey: "navigation.history",
        accessLevel: 100,
        mini: "Ι",
        component: TablesHistoryPage,
      },
      {
        path: "/table-sales",
        layout: "/admin",
        name: "ΠΩΛΗΣΕΙΣ ΤΡΑΠΕΖΙΩΝ",
        translationKey: "navigation.tableSales",
        accessLevel: 100,
        mini: "ΠΤ",
        component: TablesStatsPage,
      },
      {
        path: "/tables",
        layout: "/admin",
        name: "ΤΡΑΠΕΖΙΑ",
        translationKey: "navigation.tables",
        accessLevel: 100,
        mini: "Τ",
        component: TableListPage,
      },
    ],
  },
  {
    collapse: true,
    name: "DELIVERY",
    translationKey: "navigation.delivery",
    icon: "nc-icon nc-delivery-fast",
    path: "/delivery",
    accessLevel: 100,
    state: "openDelivery",
    views: [
      {
        path: "/delivery-guy-sales",
        layout: "/admin",
        name: "ΔΙΑΝΟΜΕΙΣ",
        translationKey: "navigation.couriers",
        accessLevel: 100,
        mini: "Δ",
        component: DeliveryGuysSalesPage,
      },
      {
        path: "/platform-sales",
        layout: "/admin",
        name: "ΠΩΛΗΣΕΙΣ ΕΦΑΡΜΟΓΩΝ",
        translationKey: "navigation.platformSales",
        accessLevel: 100,
        mini: "ΠΕ",
        component: PlatformSalesPage,
      },
    ],
  },
  {
    collapse: true,
    name: "ΚΑΤΑΛΟΓΟΣ",
    translationKey: "navigation.catalogue",
    icon: "nc-icon nc-paper-2",
    path: "/catalogue",
    accessLevel: 0,
    state: "openCatalogue",
    views: [
      {
        path: "/pricelists",
        layout: "/admin",
        name: "ΤΙΜΟΚΑΤΑΛΟΓΟΙ",
        translationKey: "navigation.priceLists",
        accessLevel: 0,
        mini: "Τ",
        component: PricelistListPage,
      },
      {
        path: "/categories",
        layout: "/admin",
        name: "ΚΑΤΗΓΟΡΙΕΣ",
        translationKey: "navigation.categories",
        accessLevel: 0,
        mini: "Κ",
        component: CategoryListPage,
      },
      {
        path: "/extra-categories",
        layout: "/admin",
        name: "ΚΑΤΗΓΟΡΙΕΣ EXTRA",
        translationKey: "navigation.extraCategories",
        accessLevel: 0,
        mini: "KE",
        component: CategoryExtraListPage,
      },
      {
        path: "/products",
        layout: "/admin",
        name: "ΕΙΔΗ",
        translationKey: "navigation.products",
        accessLevel: 0,
        mini: "Ε",
        component: ProductListPage,
      },
      {
        path: "/extras",
        layout: "/admin",
        name: "EXTRAS",
        translationKey: "navigation.extras",
        accessLevel: 0,
        mini: "E",
        component: ExtraListPage,
      },
      {
        path: "/products-integration",
        layout: "/admin",
        name: "ΑΝΤΙΣΤΟΙΧΙΣΗ",
        translationKey: "navigation.matching",
        accessLevel: 0,
        mini: "Α",
        component: ProductsIntegrationPage,
      },
    ],
  },
  {
    path: "/stores",
    layout: "/admin",
    name: "Καταστηματα",
    translationKey: "navigation.stores",
    icon: "nc-icon nc-pin-3",
    accessLevel: 0,
    component: StoreListPage,
  },
  {
    path: "/pricelist/:id",
    layout: "/admin",
    name: "Επεξεργασία Τιμοκαταλόγου",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: PricelistPage,
  },
  {
    path: "/pricelist",
    layout: "/admin",
    name: "Δημιουργία Τιμοκαταλόγου",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: PricelistPage,
  },
  {
    path: "/category/:id",
    layout: "/admin",
    name: "Επεξεργασία Κατηγορίας",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: CategoryPage,
  },
  {
    path: "/category",
    layout: "/admin",
    name: "Δημιουργία Κατηγορίας",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: CategoryPage,
  },
  {
    path: "/extra-category/:id",
    layout: "/admin",
    name: "Επεξεργασία κατηγορίας Extra",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: CategoryExtraPage,
  },
  {
    path: "/extra-category",
    layout: "/admin",
    name: "Δημιουργία κατηγορίας Extra",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: CategoryExtraPage,
  },
  {
    path: "/product/:id",
    layout: "/admin",
    name: "Επεξεργασία Είδους",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: ProductPage,
  },
  {
    path: "/extra/:id",
    layout: "/admin",
    name: "Επεξεργασία Extra",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: ExtraPage,
  },
  {
    path: "/extra",
    layout: "/admin",
    name: "Δημιουργία Extra",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: ExtraPage,
  },
  {
    path: "/product",
    layout: "/admin",
    name: "Δημιουργία Είδους",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: ProductPage,
  },
  {
    path: "/table/:id",
    layout: "/admin",
    name: "Επεξεργασία Τραπεζιού",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: TablePage,
  },
  {
    path: "/table",
    layout: "/admin",
    name: "Δημιουργία Τραπεζιού",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: TablePage,
  },
  {
    path: "/table-region/:id",
    layout: "/admin",
    name: "Επεξεργασία Περιοχής τραπεζιού",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: TableRegionPage,
  },
  {
    path: "/table-region",
    layout: "/admin",
    name: "Δημιουργία Περιοχής τραπεζιού",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: TableRegionPage,
  },
  {
    path: "/payment-method/:id",
    layout: "/admin",
    name: "Επεξεργασία Τρόπου Πληρωμής",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: PaymentMethodPage,
  },
  {
    path: "/payment-method",
    layout: "/admin",
    name: "Δημιουργία Τρόπου Πληρωμής",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: PaymentMethodPage,
  },
  {
    path: "/store-user/:id",
    layout: "/admin",
    name: "Επεξεργασία Χρήστη Καταστήματος",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: StoreUserPage,
  },
  {
    path: "/store-user",
    layout: "/admin",
    name: "Δημιουργία Χρήστη Καταστήματος",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: StoreUserPage,
  },
  {
    path: "/users",
    layout: "/admin",
    name: "Χρηστες Cloud",
    translationKey: "navigation.cloudUsers",
    icon: "nc-icon nc-circle-09",
    accessLevel: 200,
    component: UserListPage,
  },
  {
    path: "/user/:id",
    layout: "/admin",
    name: "Επεξεργασία Χρήστη",
    icon: "nc-icon nc-circle-09",
    accessLevel: 0,
    hideInSidebar: true,
    component: UserPage,
  },
  {
    path: "/user",
    layout: "/admin",
    name: "Δημιουργία Χρήστη",
    icon: "nc-icon nc-circle-09",
    accessLevel: 200,
    hideInSidebar: true,
    component: UserPage,
  },
  {
    path: "/attributes",
    layout: "/admin",
    name: "Δυνατοτητες",
    translationKey: "navigation.features",
    icon: "nc-icon nc-palette",
    accessLevel: 300,
    component: AttributeListPage,
  },
  {
    path: "/attribute/:id",
    layout: "/admin",
    name: "Επεξεργασία Δυνατότητας",
    icon: "nc-icon nc-circle-09",
    accessLevel: 300,
    hideInSidebar: true,
    component: AttributePage,
  },
  {
    path: "/attribute",
    layout: "/admin",
    name: "Δημιουργία Δυνατότητας",
    icon: "nc-icon nc-circle-09",
    accessLevel: 300,
    hideInSidebar: true,
    component: AttributePage,
  },
  {
    path: "/licenses",
    layout: "/admin",
    name: "Αδειες",
    translationKey: "navigation.licenses",
    icon: "nc-icon nc-badge",
    accessLevel: 200,
    component: LicenseListPage,
  },
  {
    path: "/license/:id",
    layout: "/admin",
    name: "Επεξεργασία Άδειας",
    icon: "nc-icon nc-circle-09",
    accessLevel: 200,
    hideInSidebar: true,
    component: LicensePage,
  },
  {
    path: "/license",
    layout: "/admin",
    name: "Δημιουργία Άδειας",
    icon: "nc-icon nc-circle-09",
    accessLevel: 200,
    hideInSidebar: true,
    component: LicensePage,
  },
  {
    path: "/store/:id",
    layout: "/admin",
    name: "Επεξεργασία Καταστήματος",
    icon: "nc-icon nc-circle-09",
    accessLevel: 200,
    hideInSidebar: true,
    component: StorePage,
  },
  {
    path: "/store-v2/:id",
    layout: "/admin",
    name: "Επεξεργασία Καταστήματος",
    icon: "nc-icon nc-circle-09",
    accessLevel: 200,
    hideInSidebar: true,
    component: StorePage,
  },
  {
    path: "/store",
    layout: "/admin",
    name: "Δημιουργία Καταστήματος",
    icon: "nc-icon nc-circle-09",
    accessLevel: 200,
    hideInSidebar: true,
    component: StorePage,
  },
  {
    path: "/login-page",
    layout: "/auth",
    name: "Login Page",
    mini: "LP",
    hideInSidebar: true,
    component: LoginPage,
  },
  {
    path: "*",
    layout: "/auth",
    name: "Redirect",
    mini: "LP",
    hideInSidebar: true,
    component: () => <Redirect to="/auth/login-page" />,
  },
  {
    path: "*",
    layout: "/admin",
    name: "Redirect",
    mini: "LP",
    hideInSidebar: true,
    component: () => <Redirect to="/admin/dashboard" />,
  },
];
export default hipposRoutes;
